import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import FileUploader from '../components/FileUploader';
import { buildFormData, uploadErrorMessage } from '../utils/fileUpload';
import '../styles/formPage.css';

const PortfolioWrite = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [url, setUrl] = useState('');
  const [type, setType] = useState('');
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('userInfo')) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return alert('제목을 입력해주세요.');
    if (!content.trim()) return alert('내용을 입력해주세요.');
    if (images.length > 5) return alert('이미지는 최대 5장까지 업로드할 수 있습니다.');

    try {
      setLoading(true);
      const formData = buildFormData(
        {
          title: title.trim(),
          content: content.trim(),
          url: url.trim() || null,
          type: type.trim() || null,
        },
        { images }
      );
      await API.post('/portfolio', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert('포트폴리오가 생성되었습니다.');
      navigate('/portfolio');
    } catch (err) {
      alert(uploadErrorMessage(err, '포트폴리오 생성에 실패했습니다.'));
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (window.confirm('작업을 취소하시겠습니까? 변경사항이 저장되지 않습니다.')) navigate('/portfolio');
  };

  return (
    <div className="form-page container container--narrow section">
      <div className="form-page__head">
        <span className="section__eyebrow">Portfolio</span>
        <h1 className="form-page__title">포트폴리오 작성</h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="field">
          <label className="field__label" htmlFor="title">제목 <span className="req">*</span></label>
          <input id="title" className="input" type="text" value={title}
            onChange={(e) => setTitle(e.target.value)} placeholder="제목을 입력하세요" disabled={loading} />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="content">내용 <span className="req">*</span></label>
          <textarea id="content" className="textarea" value={content}
            onChange={(e) => setContent(e.target.value)} placeholder="내용을 입력하세요" disabled={loading} />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="url">관련 URL (선택)</label>
          <input id="url" className="input" type="url" value={url}
            onChange={(e) => setUrl(e.target.value)} placeholder="https://..." disabled={loading} />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="type">분류 (선택)</label>
          <input id="type" className="input" type="text" value={type}
            onChange={(e) => setType(e.target.value)} placeholder="예: 디자인, 개발" disabled={loading} />
        </div>

        <FileUploader
          id="images"
          label="이미지 (최대 5장)"
          hint="이미지 파일을 여러 개 선택할 수 있습니다"
          accept="image/*"
          image
          files={images}
          onChange={setImages}
          disabled={loading}
        />

        <div className="form-actions">
          <button type="button" className="btn btn--ghost" onClick={handleCancel} disabled={loading}>취소</button>
          <button type="submit" className="btn btn--primary" disabled={loading}>
            {loading ? '처리 중...' : '작성하기'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PortfolioWrite;
